import { useState } from "react"

export default function useObjectState<ObjectType>(
    initialState: ObjectType
): [ObjectType, (update: Partial<ObjectType>) => void] {
    const [objectState, setObjectState] = useState(initialState)

    const updateObjectState = (update: Partial<ObjectType>) => {
        setObjectState((curState) => ({ ...curState, ...update }))
    }

    return [objectState, updateObjectState]
}
